import { connect } from 'react-redux';
import { createSubmitAction } from '../../app/forms';
import {routerActions} from 'react-router-redux';
import { FormattedMessage } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { getAddressbooks, selectAddressbooks } from '../addressbooks';
import { getRegions, selectRegions } from '../../app/regions';
import CreateAddressForm from '../forms/CreateAddress';
import ImmutablePropTypes from 'react-immutable-proptypes';
import IsSpinning from '../../app/containers/IsSpinning';
import Page from '../../app/components/Page';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Spinner from '../../app/components/Spinner';

import {
    CREATE_LOCATION_SUBMIT,
    CREATE_LOCATION_SUCCESS,
    CREATE_LOCATION_FAILURE,
} from '../locations';

export class AddressbookCreator extends Component {
    static propTypes = {
        addressbooks: ImmutablePropTypes.map.isRequired,
        children: PropTypes.node,
        dispatch: PropTypes.func.isRequired,
        regions: ImmutablePropTypes.map.isRequired,
    };

    componentWillMount() {
        this.props.dispatch(getAddressbooks({}, { spinner: 'addressbook' }));
        this.props.dispatch(getRegions({}, { spinner: 'addressbook' }));
    }

    handleSubmitSuccess() {
        window.scrollTo(0, 0);
        this.props.dispatch(routerActions.push("/addressbook"));
    }

    handleSubmitFailure() {
        window.scrollTo(0, 0);
    }

    render() {
        const { addressbooks, regions } = this.props;

        return (
            <Page.Body>
                <Page.Section depth={0}>
                    <h1>
                        <FormattedMessage id='frontend.addressbook.headline.new_address' />
                    </h1>
                </Page.Section>
                <Page.Section>
                    <Page.Content>
                        <CreateAddressForm.Component
                            addressbooks={addressbooks}
                            regions={regions}
                            onSubmit={createSubmitAction(
                                CREATE_LOCATION_SUBMIT,
                                CREATE_LOCATION_SUCCESS,
                                CREATE_LOCATION_FAILURE
                            )}
                            onSubmitSuccess={this.handleSubmitSuccess.bind(this)}
                            onSubmitFail={this.handleSubmitFailure}
                        />
                    </Page.Content>
                    <IsSpinning id='addressbook'>
                        <Spinner />
                    </IsSpinning>
                </Page.Section>
            </Page.Body>
        );
    }
}

export default withRouter(connect(state => ({
    addressbooks: selectAddressbooks(state),
    regions: selectRegions(state),
}))(AddressbookCreator));
